import { TableColumn, TableConfig, SORT_ORDER } from "../../../@shared/models/table.models";

export const PROJECT_DASHBOARD_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "user.fullName",
        header: "Name",
        type: "custom",
        template: "nameTemplate",
        width: "30%"
    },
    {
        field: "progress",
        header: "Progress",
        type: "custom",
        template: "progressTemplate",
        width: "35%"
    },
    {
        field: "toAnswer",
        header: "To Answer",
        type: "custom",
        template: "toAnswerTemplate",
        width: "20%"
    },
    {
        field: "toApprove",
        header: "To Approve",
        type: "custom",
        template: "toApproveTemplate",
        width: "20%"
    },
    {
        field: "lastNotifiedAt",
        header: "Last notified",
        type: "custom",
        template: "lastNotifiedTemplate",
        width: "15%"
    }
];

export const PROJECT_DASHBOARD_TABLE_CONFIG: TableConfig = {
    selectable: true,
    paginator: false,
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No assignees found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { } // Will be implemented in the component
};

